import reactUpdate from 'immutability-helper';

import {DataTable} from 'notebook/data-tables/DataTableConstants';
import * as DataTableUtil from 'notebook/data-tables/DataTableUtil';
import {Table} from 'notebook/tables/TableConstants';
import LegacyDropdownMenuItem from 'ui-library/dropdowns/legacy/LegacyDropdownMenuConstants';

interface DataTableNoLinkContextProps {
  children: (args: {
    table: Table;
    sampleIds: Array<string> | null;
    addMenuItems: Array<LegacyDropdownMenuItem>;
  }) => JSX.Element;
  dataTable: DataTable;
  onUpdate: (dataTable: DataTable) => void;
}

const DataTableNoLinkContext: React.SFC<DataTableNoLinkContextProps> = (
  props: DataTableNoLinkContextProps
): JSX.Element =>
  props.children({
    table: DataTableUtil.convertDataTableToTable(props.dataTable),
    sampleIds: null,
    addMenuItems: [
      {
        name: 'Add row',
        icon: 'compose',
        handleOnClick: () => {
          props.onUpdate(
            reactUpdate(props.dataTable, {
              rows: {
                $push: [
                  DataTableUtil.generateDataTableRow(props.dataTable.config, props.dataTable.rows.length, {}),
                ],
              },
            })
          );
        },
      },
    ],
  });

export default DataTableNoLinkContext;
